import { Button, Col, Form, Input, Row, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { request } from "../../../../utils/request";

const DEFAULT_PASSWORD = "123456";
const GROUP_KHACH_HANG = {
	group_id: "65388c52f87b592140dc3b8e",
	group_name: "Khách hàng",
};

const getErrorMessage = (error, fallback) => {
	const message = error?.response?.data?.error;
	return typeof message === "string" && message ? message : fallback;
};

export default function Account({ dataModal, messageApi, onSuccess }) {
	const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1024px)" });
	const isMobile = useMediaQuery({ query: "(max-width: 640px)" });

	const layout = {
		labelCol: {
			className: "min-w-[120px]",
			span: isMobile ? 24 : isTabletOrMobile ? 10 : 6,
		},
		wrapperCol: { span: isTabletOrMobile ? 24 : 18 },
	};

	const [account, setAccount] = useState("");
	const [password, setPassword] = useState(DEFAULT_PASSWORD);
	const [name, setName] = useState("");
	const [loading, setLoading] = useState(false);
	// Đã tạo participant nhưng chưa liên kết được vào customer -> chỉ thử lại bước liên kết
	const [createdAccount, setCreatedAccount] = useState(null);

	useEffect(() => {
		setAccount(dataModal?.dien_thoai || dataModal?.email || "");
		setPassword(DEFAULT_PASSWORD);
		setName(
			`${dataModal?.ho_ten_dem ?? ""} ${dataModal?.ten_kh ?? ""}`.trim(),
		);
		setCreatedAccount(null);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dataModal?._id]);

	const preventEnterSubmit = (e) => {
		if (e.key === "Enter") e.preventDefault();
	};

	const handleCreateAccount = async () => {
		const email = (createdAccount || account).trim();
		if (!email || !password || !name.trim()) {
			messageApi.open({
				type: "warning",
				content: "Vui lòng nhập đủ tài khoản, mật khẩu và tên hiển thị",
			});
			return;
		}
		if (!dataModal?._id) return;

		const idApp = localStorage.getItem("id_app");
		const headers = {
			"X-Access-Token": localStorage.getItem("token"),
			"Content-Type": "application/json",
		};

		setLoading(true);
		if (!createdAccount) {
			try {
				await request.post(
					`api/${idApp}/participant`,
					{
						...GROUP_KHACH_HANG,
						admin: true,
						active: false,
						auto_create_user: true,
						email,
						name: name.trim(),
						password,
					},
					{ headers },
				);
				setCreatedAccount(email);
			} catch (error) {
				setLoading(false);
				messageApi.open({
					type: "error",
					content: getErrorMessage(error, "Tạo tài khoản thất bại"),
				});
				return;
			}
		}

		try {
			await request.put(
				`api/${idApp}/customer/${dataModal._id}`,
				{ of_user: email, _id: dataModal._id },
				{ headers },
			);
			messageApi.open({
				type: "success",
				content: "Tạo tài khoản thành công",
			});
			onSuccess && onSuccess(email);
		} catch (error) {
			messageApi.open({
				type: "error",
				content:
					"Đã tạo tài khoản nhưng chưa liên kết được với khách hàng, bấm lại để thử liên kết",
			});
		} finally {
			setLoading(false);
		}
	};

	if (dataModal?.of_user) {
		return (
			<Row className="!m-0" gutter={[8, 8]}>
				<Col span={24}>
					<Form.Item
						label="Trạng thái"
						labelCol={{ ...layout.labelCol }}
						wrapperCol={{ ...layout.wrapperCol }}
					>
						<Tag color="green">
							Đã có tài khoản: {dataModal.of_user}
						</Tag>
					</Form.Item>
				</Col>
			</Row>
		);
	}

	return (
		<Row className="!m-0" gutter={[8, 8]}>
			<Col span={isMobile ? 24 : 12}>
				<Form.Item
					label="Tài khoản"
					labelCol={{ ...layout.labelCol }}
					wrapperCol={{ ...layout.wrapperCol }}
					extra="Mặc định lấy số điện thoại của khách hàng, có thể chỉnh sửa"
				>
					<Input
						value={account}
						onChange={(e) => setAccount(e.target.value)}
						onKeyDown={preventEnterSubmit}
						placeholder="nhập tài khoản"
						autoComplete="off"
						disabled={!!createdAccount}
					/>
				</Form.Item>
			</Col>
			<Col span={isMobile ? 24 : 12}>
				<Form.Item
					label="Mật khẩu"
					labelCol={{ ...layout.labelCol }}
					wrapperCol={{ ...layout.wrapperCol }}
					extra="Mặc định 123456, có thể chỉnh sửa"
				>
					<Input.Password
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						onKeyDown={preventEnterSubmit}
						placeholder="nhập mật khẩu"
						autoComplete="new-password"
					/>
				</Form.Item>
			</Col>
			<Col span={isMobile ? 24 : 12}>
				<Form.Item
					label="Tên hiển thị"
					labelCol={{ ...layout.labelCol }}
					wrapperCol={{ ...layout.wrapperCol }}
				>
					<Input
						value={name}
						onChange={(e) => setName(e.target.value)}
						onKeyDown={preventEnterSubmit}
						placeholder="nhập tên hiển thị"
						autoComplete="off"
					/>
				</Form.Item>
			</Col>
			<Col span={24}>
				<Button
					className="btn_primary hover:!text-white"
					loading={loading}
					onClick={handleCreateAccount}
				>
					{createdAccount ? "Liên kết lại tài khoản" : "Tạo tài khoản"}
				</Button>
			</Col>
		</Row>
	);
}
